import { oz } from '@weft/utils';
import { NewUsageLineItemSchema } from './new-usage-line-item-schema';
import { TiersUsageMapInputSchema } from './tiers-usage-map';

export const UsageLineItemInputSchema = oz.object(NewUsageLineItemSchema.shape)
  .omit({ tiersUsageMap: true })
  .extend({
    tiersUsageMap: TiersUsageMapInputSchema,
  })
  .partial()
  .required({ type: true })
  .openapi('UsageLineItemInput');

export type UsageLineItemInput = oz.infer<typeof UsageLineItemInputSchema>;